export const uppercase = (text: string) => <span className='text-uppercase'>{text}</span>;
